import { pharmacyClient } from "@/connect";
import { ItemType } from "@/gen/inventory/common_pb";

export const getOutOfStock = async (page: number, pageSize: number, type: "MEDICAL" | "NON_MEDICAL") => {
  return await pharmacyClient.getInventory({
    page,
    pageSize,
    filter: {
      isOutOfStock: true,
      itemType: type === "MEDICAL" ? ItemType.MEDICAL : ItemType.NON_MEDICAL
    },
  });
};